import React from 'react';

/**
 * Render a message indicating no search results found.
 * @example
 * renderNoResults()
 * <div className="no-result">...</div>
 * @returns {JSX.Element} A JSX element displaying a 'Result Not Found' message with user guidance.
 * @description
 *   - The component includes semantic HTML tags for improved SEO.
 *   - Utilizes classNames for styling consistency across the application.
 */
const NoDataTextComponent = () => {
  return (
    <div className="no-result text-center pt-20 pb-20">
      {/* <p className="MuiTypography-h3 fw600 mb-10">Search here</p> */}
      <p className="MuiTypography-h3 fw600 mb-10">Result Not Found</p>
      <p className="text-text lh-14 mb-8">
        We're sorry you couldn't find what you were looking for.
      </p>
      <p className="text-text lh-14 mb-8">Please try a different keyword.</p>
    </div>
  );
};

export default NoDataTextComponent;
